import { DirectiveBinding } from "vue"

interface LongPressEl extends HTMLElement {
  __lpStart?: (e: Event) => void
  __lpCancel?: () => void
  __lpTimer?: number | null
}

export default {
    beforeMount(el: LongPressEl, binding: DirectiveBinding) {
        const delay = typeof binding.value === "object" && binding.value.delay
            ? binding.value.delay
            : 1000
        const handler = (e: Event) => {
            // вызывать переданную функцию
            if (typeof binding.value === "function") {
                binding.value(e)
            }
            else if (binding.value && typeof binding.value.handler === "function") {
                binding.value.handler(e)
            }
        }
        const start = (e: Event) => {
            if (el.__lpTimer == null) {
                el.__lpTimer = window.setTimeout(() => {
                    handler(e)
                    clearTimeout(el.__lpTimer!)
                    el.__lpTimer = null
                }, delay)
            }
        }
        const cancel = () => {
            if (el.__lpTimer != null) {
                clearTimeout(el.__lpTimer)
                el.__lpTimer = null
            }
        }
        el.addEventListener("touchstart", start)
        el.addEventListener("mousedown", start)
        el.addEventListener("touchend", cancel)
        el.addEventListener("mouseleave", cancel)
        el.addEventListener("mouseup", cancel)
        el.__lpStart = start
        el.__lpCancel = cancel
    },

    unmounted(el: LongPressEl) {
        el.removeEventListener("touchstart", el.__lpStart!)
        el.removeEventListener("mousedown", el.__lpStart!)
        el.removeEventListener("touchend", el.__lpCancel!)
        el.removeEventListener("mouseleave", el.__lpCancel!)
        el.removeEventListener("mouseup", el.__lpCancel!)
        delete el.__lpStart
        delete el.__lpCancel
        delete el.__lpTimer
    }
}
